<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template> 

<script>
export default {
	name: 'app',
	mounted() {
        // 添加页面刷新或关闭时的事件监听
        window.addEventListener('beforeunload', this.clearLocalStorage);
	},
    beforeDestroy() {
        // 移除事件监听器，避免内存泄漏
        window.removeEventListener('beforeunload', this.clearLocalStorage);
    },
	methods:{
		clearLocalStorage() {
            // 清除注册流程相关的localStorage数据
            localStorage.removeItem('basicInfoData');
            localStorage.removeItem('specialtyInfoData');
            localStorage.removeItem('replenishInfoData');
            localStorage.removeItem('filteredUrl');
        }
	},
}
</script>
<style>
    @import "./assets/font/iconfont.css";
    body {
        margin: 0px;
        padding: 0px;
        background: #fff;
        /* font-size: 14px; */
        font: 14px/1.5 arial,tahoma,'Hiragino Sans GB','Hiragino Sans GB W3','Microsoft Yahei',\5b8b\4f53;
    }
    html, body{
        width: 100%;
        height: 100%;
        font-size: 14px;
    }
    a:link { 
        color: #333; 
        text-decoration: none;
    }
    a:visited { 
      color: #333;
     } 
    a:focus { 
        outline: none; 
    }
    ul li{
        list-style: none;
    }
    *{
        margin: 0;
        padding: 0;
        outline: 0;
    }
    label{
        font-weight: 100;
    }
    img {
        width: 100%;
         border: 0 none; 
         vertical-align: top; 
    }
    button{
        cursor: pointer;
        outline:none;
    }
    input[type="file"] {
      cursor: pointer;
    }
    input{
        -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
        background: transparent;
        border: 0;
        font-size: 100%;
        margin: 0;
        outline: 0;
        padding: 0;
        vertical-align: baseline;
    }
    input::placeholder {
        color: #c1c5ce
    }
    #app {
        /* position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%; */
    }
    .Text2{
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .Text1{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>